export const GET_TRANSACTION_DETAILS_START = "GET_TRANSACTION_DETAILS_START";
export const GET_TRANSACTION_DETAILS_SUCCESS = "GET_TRANSACTION_DETAILS_SUCCESS";
export const GET_TRANSACTION_DETAILS_ERROR = "GET_TRANSACTION_DETAILS_ERROR";